export default __webpack_public_path__ + "static/media/css.afb434f6.svg";